/**
 * @file store
 * @author YongZhang<zhangyong06@baidu.com>
 */
'use strict';
import Vue from 'vue';
import Vuex from 'vuex';

import Industry from './modules/Industry';
import lawStore from './modules/law-store';

import {passportOrigin} from '../../config/';
Vue.use(Vuex);
Vue.config.devtools = true;


export const config = {
    state: {
    },
    mutations: {
    },
    actions: {
        logout(e, authToken) {
            let href
                = location.protocol
                    + '//' + location.host
                    + '/bp/account/login'
                    + (authToken ? '?authToken=' + authToken : '');
            let passUrl = `${passportOrigin}/?logout`;
            window.location = passUrl + '&tpl=lvlin&u=' + encodeURI(href);
        }
    },
    modules: {
        Industry,
        lawStore
    }
};
export default new Vuex.Store(config);
